import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import "@quintype/arrow/dist/app.scss";
import { AdService } from "../../../components/ad-service";
import { WidgetComponent } from "../../../components/Widget";
import "./arrow.m.css";
import { decodeCustomCode } from "../../../../utils/decodeCustomCode";

// this will be the wrapper inside ahead
const arrowWrapper = Component => ({ collection, metadata = {} }) => {
  const pageType = useSelector(state => get(state, ["qt", "pageType"]), "");
  const supportedPages = {
    "home-page": "home",
    "section-page": "section",
    "collection-page": "section",
    "": ""
  };
  const theme = useSelector(state =>
    get(state, ["qt", "config", "pagebuilder-config", supportedPages[pageType], "pageSetting", "bgColor"], "")
  );
  const config = get(metadata, ["config"], {});
  let { adType = "", targetingId = "", widget = "" } = config;

  const adComponent = () => {
    return (
      <div className="app-ad app-ad--story-horizontal">
        <AdService
          adtype={adType}
          adTargetingId={targetingId}
          layoutName="PageBuilder"
          slotId={`PB-${get(metadata, ["rowId"], "")}`}
        />
      </div>
    );
  };
  const widgetComp = () => {
    if (typeof window === "undefined") {
      global.window = undefined;
    }
    try {
      if (window) window.atob(widget);
    } catch (e) {
      widget = "";
    }
    return (
      <div className="app-ad app-ad--story-horizontal">
        <WidgetComponent widgetValue={decodeCustomCode(widget)} />
      </div>
    );
  };

  const updateComp = ({ type }) => {
    switch (type) {
      case "ad":
        return adComponent;
      case "widget":
        return widgetComp;
      default:
        return null;
    }
  };

  const updateWithComponent = config => {
    const pbRowsConfig = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", "general", "rows"], {})
    );

    // Arrow needs the config values like sectionTagTemplate directly under config prop.
    // TODO: May need to flatten the rowConfig sometime.
    const sectionTagTemplate = get(
      pbRowsConfig,
      ["sectionTag", "template"],
      get(pbRowsConfig, ["sectionTagTemplate"], "solid")
    );
    const collectionNameTemplate = get(pbRowsConfig, ["collectionNameTemplate"], "");
    const borderColor = get(pbRowsConfig, ["sectionTag", "color"], "");
    const collectionNameBorderColor = get(pbRowsConfig, ["titleStyle", "underLineColor"], "");

    // borderColor to change sectionTag color. TODO: rename to sectionTagColor
    let updatedConfig = {
      theme,
      ...config,
      sectionTagTemplate,
      collectionNameTemplate,
      borderColor,
      collectionNameBorderColor
    };
    const { type } = get(updatedConfig, ["slotConfig", 0], {});

    if (!updatedConfig.slotConfig) return updatedConfig;
    updatedConfig.slotConfig[0].component = updateComp({ type });
    return updatedConfig;
  };

  return (
    <div style={{ maxWidth: "1172px", margin: "auto" }}>
      <Component collection={collection} config={updateWithComponent(config)} />
    </div>
  );
};
export { arrowWrapper };
